<template>
  <div class="container">
    <div class="gallery-container">
      <img
        :src="descriptiveImages[0].url"
        :alt="descriptiveImages[0].description"
        class="gallery-image main-image"
        @click="visible = true"
        style="border-radius: 0.375rem;aspect-ratio: 3 / 2;"
      />
      <img
        v-for="image in descriptiveImages.slice(1, 5)"
        :key="image.url"
        :src="image.url"
        :alt="image.description"
        class="gallery-image"
        @click="visible = true"
        style="border-radius: 0.375rem;aspect-ratio: 3 / 2;"
      />

      <div class="image-overlay">
            <div class="image-counter">
              <i class="fas fa-images"></i>
              {{ images.length }}
            </div>
          </div>
    </div>

    <b-modal :active.sync="visible" :width="960" >
      <div class="" style="background-color: white;padding:20px">
        <header class="">
          <p class="">
            <span class="is-flex is-align-items-center is-size-5">
              Hotel Property
            </span>
          </p>
        </header>
        <section class="overflow-y: scroll">
          <div class="columns is-multiline is-variable is-4">
            <div v-for="(image, index) in descriptiveImages" :key="index" class="column is-6">
              <figure class="image is-3by2">
                <b-image
                  :src="image.url"
                  :alt="image.description"
                  @click="openPreview(image.url)"
                  class="has-ratio"
                  style="border-radius: 0.25rem;"
                />
              </figure>
              <p class="has-text-centered mt-2 is-size-6 font-medium">
                {{ image.description }}
              </p>
            </div>
          </div>
        </section>
        <footer class="">
          <button class="button is-info is-outlined" @click="visible = false">
            Close
          </button>
        </footer>
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  props: {
    images: Array,
  },
  data() {
    return {
      visible: false,
    }
  },
  computed: {
    descriptiveImages() {
      return this.images
        .filter((image) => image.url && image.description)
        .sort((a, b) => (a.description === "Exterior" ? -1 : 1))
    },
  },
  methods: {
    openPreview(url) {
      this.$buefy.modal.open({
        parent: this,
        component: {
          template: `
              <div class="modal-card" style="width: auto">
                <img :src="url" style="max-width: 100%; max-height: 80vh;" />
              </div>
            `,
          props: ["url"],
        },
        props: {
          url: url,
        },
        hasModalCard: true,
        trapFocus: true,
      })
    },
  },
}
</script>

<style scoped>
.gallery-container {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-template-rows: repeat(2, 1fr);
  gap: 0.25rem;
  height: 400px;
  position: relative;
}


.gallery-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  cursor: pointer;
}
.main-image {
  grid-column: span 2;
  grid-row: span 2;
}

.image-overlay {
  position: absolute;
  bottom: 10px;
  right: 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  pointer-events: none;
}

.image-counter {
  background: rgba(0, 0, 0, 0.5);
  color: white;
  padding: 0.25rem 1.25rem;
  border-radius: 9999px;
  font-size: 1.1rem;
  align-self: center;
  margin-bottom: 1rem;
}
@media screen and (max-width: 768px) {
  .gallery-container {
    grid-template-columns: 1fr;
    grid-template-rows: 1fr;
    height: 300px;
  }
  .gallery-image:not(.main-image) {
    display: none;
  }
  .main-image {
    grid-column: 1;
    grid-row: 1;
  }
}
</style>
